import type { Directive } from 'vue'

const vDis: Directive<HTMLElement, boolean> = {
	mounted(el, binding) {
		updateClass(el, binding)
	},
	updated(el, binding) {
		updateClass(el, binding)
	},
}

function updateClass(el: HTMLElement, binding: any) {
	queueMicrotask(() => {
		const { value, modifiers } = binding

		if (value) {
			el.classList.add('to-dis')
			if (modifiers.opacity) {
				el.classList.add('type-opacity')
			} else {
				el.classList.remove('type-opacity')
			}
			if (modifiers.select) {
				el.classList.add('type-select')
			} else {
				el.classList.remove('type-select')
			}
		} else {
			el.classList.remove('to-dis')
			el.classList.remove('type-opacity')
		}
	})
}

export default vDis
